import { getQueryStringByName } from '@/utils/helper';
import { useEffect } from 'react';
import { useStore } from '@/store';


export default function useSwitchConfig() {
  const { leaseConfig, fetchLeaseConfig } = useStore();

  useEffect(() => {
    const wapid = getQueryStringByName('wapid');
    const cinemaId = getQueryStringByName('cinemaId');
    fetchLeaseConfig(`key_${wapid}_${cinemaId}`, wapid, cinemaId);
  }, []);

  return {
    leaseConfig,
  };
}
